import 'reflect-metadata';

import { IDynamicComponentMetadata } from '../types/dynamic-component-metadata.interface';
import { DynamicMetadataType } from '../types/dynamic-metadata-type.enum';

export function DynamicComponent(metadata: IDynamicComponentMetadata): ClassDecorator {
  return (target: object) => {
    Reflect.defineMetadata(DynamicMetadataType.Component, metadata, target);
  };
}
